const NON_TEXT_INPUT_TYPES = new Set(['button', 'checkbox', 'color', 'file', 'image', 'radio', 'range', 'reset', 'submit'])

// Typing inside a text field must not count as keyboard navigation,
// otherwise the focus ring appears as soon as the user starts writing.
function isTextEntry(el: EventTarget | null) {
  if (!(el instanceof HTMLElement))
    return false
  if (el.isContentEditable || el instanceof HTMLTextAreaElement)
    return true
  return el instanceof HTMLInputElement && !NON_TEXT_INPUT_TYPES.has(el.type)
}

export default defineNuxtPlugin(() => {
  const html = document.documentElement

  function onKeydown(e: KeyboardEvent) {
    if (e.key !== 'Tab' && isTextEntry(e.target))
      return
    html.dataset.inputModality = 'keyboard'
  }

  function setPointer() {
    html.dataset.inputModality = 'pointer'
  }

  useEventListener(window, 'keydown', onKeydown, { capture: true })
  useEventListener(window, 'pointerdown', setPointer, { capture: true })
  useEventListener(window, 'touchstart', setPointer, { capture: true, passive: true })
})
